import { CountryService } from '@/services/storage.service'

let country = CountryService.getCountry();

let lang = {
    "test": "test",
    "ar": {
        "menu": [
            {
                "name": "HOME",
                "path": "/"
            },
            {
                "name": "MOVIES",
                "path": "/movies"
            },
            {
                "name": "CINEMAS",
                "path": "/cinemas"
            },
            {
                "name": "PROMOTIONS",
                "path": "/promotions"
            }
        ],
        "signUpPopUp": {
            "header": "arabic hello"
        },
        "NowShowing": "يعرض الآن"
    },
    "en": {
        "menu": [
            {
                "name": "HOME",
                "path": "/"
            },
            {
                "name": "MOVIES",
                "path": "/movies"
            },
            {
                "name": "CINEMAS",
                "path": "/cinemas"
            },
            {
                "name": "PROMOTIONS",
                "path": "/promotions"
            },
            {
                "name": "REFER_SAVE",
                "path": "/refer"
            }
        ],
        "signUpPopUp": {
            "title": "english hello"
        },
        "NowShowing": "Now Showing"
    }
};
if (country && country.CountryID === '228') {
    lang.ar.menu = lang.ar.menu.filter(({ path }) => path !== '/promotions')
    lang.en.menu = lang.en.menu.filter(({ path }) => path !== '/promotions')
};


export default lang;


// WEBPACK FOOTER //
// ./src/languageData.js